'use client';

import { CTACard_Repair } from '@/components/CTACard_Repair';
import { CTACard_Replace } from '@/components/CTACard_Replace';

export default function BottomCTASection() {
	return (
		<div className="col-span-full mx-auto grid max-w-6xl gap-8 lg:grid-cols-2">
			<CTACard_Replace />
			<CTACard_Repair />
		</div>
	);
}
